import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../_metronic/_helpers";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {Link} from "react-router-dom";

export default function AsideItem({title,link="#",externalLink=false,activeTab=false,handleTabChange,tabId,svg="/media/svg/icons/Layout/Layout-4-blocks.svg"}){
	return (
		<li
			className="nav-item mb-3"
			data-toggle="tooltip"
			data-placement="rigth"
			data-container="body"
			data-boundary="window"
			title={title}
		>
			<OverlayTrigger
				placement="left"
				overlay={
					<Tooltip id="latest-project">{title}</Tooltip>
				}
			>
				{externalLink ?
					<a
						href={link}
						rel="noopener noreferrer"
						target='_blank'
						className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab && "active"}`}
						data-toggle="tab"
						data-target={`#${tabId}`}
						role="tab"
					>
						<span className="svg-icon svg-icon-lg">
							<SVG
								src={toAbsoluteUrl(
									svg
								)}
							/>
						</span>
					</a> :
					<Link
						to={link}
						className={`nav-link btn btn-icon btn-clean btn-lg ${activeTab && "active"}`}
						data-toggle="tab"
						data-target={`#${tabId}`}
						role="tab"
						onClick={() => handleTabChange(tabId)}
					>
                    <span className="svg-icon svg-icon-lg">
                      <SVG
												src={toAbsoluteUrl(
													svg
												)}
											/>
                    </span>
					</Link>
				}

			</OverlayTrigger>
		</li>
	)
}